
export default {
  name: 'VsTableGroup',
  props: {
    label: {
      type: String,
      default: null
    },
    align: {
      type: String,
      default: 'left'
    }
  },
  render() {
    return null
  }
}
